<div class="col-md-12 col-sm-12">
    <div class="text-center headerlbl">
        Your session is Expired.
    </div>
  </div>
  